import EfImg from 'elem/ui/ef-img';
import styles from './index.module.scss';
import { RuleTabModuleIdEnum } from '../Tab';
import { useLang } from '@/i18n';

const Content = () => {
    const { t } = useLang('rule');
    return (
        <div className={styles.content} id={RuleTabModuleIdEnum.Overview}>
            <EfImg
                className="img"
                pc="https://websiteoss.ecoflow.com/upload/image/1785133244221/indexkv_pc.jpg"
                h5="https://websiteoss.ecoflow.com/upload/image/1785133259563/indexkv_h5.jpg"
            />
            <div className="mask">
                <div className="text-container">
                    <h1 className="text">{t('A_text')}</h1>
                </div>
            </div>
        </div>
    );
};

export default Content;
